import React, {Component} from 'react';
const { Link } = require('react-router');

import '../../sass/headers/header.scss';


class HeaderUpload extends Component
{
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render()
    {
        const {enter} = this.props;

        return (
            <header className="headerupload">
                <div className="content">
                    <h1>Publish your amateur video</h1>
                    <div className="text-headerupload">
                        <a href="#">Back to all amateur videos</a>
                    </div>
                </div>
            </header>
        )
    }
}

export default HeaderUpload;


// WEBPACK FOOTER //
// ./src/components/upload/HeaderUpload.js